import Vue from "vue";
import Vuetify from "vuetify/lib";
import PBIcons from "@/components/Common/PBIcons";

function pbiLoader(ids, sizes, prefix) {
	const icons = {};
	if (typeof ids === "object" && ids.length >= 1) {
		for (const id of ids) {
			for (const suffix of sizes) {
				const name = `${prefix}${id}_${suffix}`;
				icons[name] = {
					component: PBIcons,
					props: {
						name,
					},
				};
			}
		}
	} else if (ids === "*") {
		require.context("@/assets/img/pbi", false, /\.svg$/).keys().forEach((key) => {
			let name = key.replace(/^(\.+\/)+|\.svg$/g,'');
			icons[name] = {
				component: PBIcons,
				props: {
					name,
				},
			};
		});
	}
	return icons;
}

Vue.use(Vuetify);

export default new Vuetify({
	theme: {
		dark: false,
		themes: {
			light: {
				'pb-green': '#54CA30',
				'dark-green': '#42A923',
				'pb-blue': '#0058B5',
				'dark-blue': '#03102F',
				'medium-blue': '#004792',
				'cool-blue': '#007BFF',
				'violet': '#4B36F8',
				'dark': '#161616',
				'midnight': '#32302F',
				'gray': '#686361',
				'medium-gray': '#95928E',
				'cool-gray': '#E0DCD7',
				'light-gray': '#F6F6F6',
				'error': '#FF1E54',
				'alert': '#FFB035',
				'white': '#FFFFFF',
			}
		},
	},
	icons: {
		iconfont: 'mdi',
		values: {
			...pbiLoader("*", ["16", "24", "32"], "pbi_")
		},
	}
});